/**
 * Libellés hono générés automatiquement (ancienne + nouvelle stratégie).
 * - Ancien : HONO JANVIER 2026 / …
 * - Ancien create_invoice : Génération NH (NH…) automatique
 * - Ancien : GENERATION NOTE D'HONORAIRE 'NH…' AUTOMATIQUE …
 * - Nouveau : GENERATION D'HONORAIRE AUTOMATIQUE DE MOIS JANVIER 2026 AVEC UN MONTANT NET A PAYER …
 */
const LEGACY_AUTO_HONO_LIBELLE_RE =
  /^HONO (?:[0-9]{4}-[0-9]{2}-[0-9]{2}|(?:JANVIER|FEVRIER|FÉVRIER|MARS|AVRIL|MAI|JUIN|JUILLET|AOÛT|AOUT|SEPTEMBRE|OCTOBRE|NOVEMBRE|DÉCEMBRE|DECEMBRE) [0-9]{4}|(?:1er|2ème|3ème|4ème) trimestre [0-9]{4}|(?:1er|2ème) semestre [0-9]{4}|[0-9]{4})$/i;

const OLD_GEN_AUTO_HONO_LIBELLE_RE =
  /^G[ée]n[ée]ration NH\s*\([^)]+\)\s*automatique$/i;

const NOTE_AUTO_HONO_LIBELLE_RE =
  /^GENERATION NOTE D['']HONORAIRE\s+'?NH\S+'?\s+AUTOMATIQUE(?:\s+DE MOIS\s+\S+\s+\d{4})?\s+AVEC UN MONTANT NET A PAYER\s+/i;

const NEW_AUTO_HONO_LIBELLE_RE =
  /^GENERATION D['']HONORAIRE\s+AUTOMATIQUE(?:\s+DE MOIS\s+\S+\s+\d{4})?\s+AVEC UN MONTANT NET A PAYER\s+/i;

export function isAutoGeneratedHonoLibelle(libelle) {
  const raw = String(libelle || '').trim();
  if (!raw) return false;
  return (
    LEGACY_AUTO_HONO_LIBELLE_RE.test(raw) ||
    OLD_GEN_AUTO_HONO_LIBELLE_RE.test(raw) ||
    NOTE_AUTO_HONO_LIBELLE_RE.test(raw) ||
    NEW_AUTO_HONO_LIBELLE_RE.test(raw)
  );
}
